import {paddingLeft} from "../utils/strings";

export const formatDate = (date:string) => date?.substr(0, date.indexOf('T')) ?? "N/A";

export const formatDate1 = (date:Date) => !date ? (
    "N/A"
) : (
    paddingLeft(date.getMonth() + 1) + "/" +
    paddingLeft(date.getDate()) + "/" +
    paddingLeft(date.getFullYear())
);

export const formatDate2 = (date:Date) => !date ? (
    "N/A"
) : (
    paddingLeft(date.getMonth() + 1) + "/" +
    paddingLeft(date.getDate()) + "/" +
    paddingLeft(date.getFullYear() % 100)
);

export const formatDateLong = (date: Date) => !date ? (
    "N/A"
) : (
    new Intl.DateTimeFormat('en-US', {weekday: 'long'}).format(date) + ", " +
    new Intl.DateTimeFormat('en-US', {month: 'short'}).format(date) + " " +
    dateOrdinal(date.getDate()) + ", " +
    new Intl.DateTimeFormat('en-US', {year: 'numeric'}).format(date) + " " +
    date.toLocaleTimeString(
        'en-US',
        {
            hour: 'numeric',
            minute: 'numeric',
            timeZoneName: 'short',
        },
    )
);

function dateOrdinal(dom) {
    if (dom == 31 || dom == 21 || dom == 1) return dom + "st";
    else if (dom == 22 || dom == 2) return dom + "nd";
    else if (dom == 23 || dom == 3) return dom + "rd";
    else return dom + "th";
};

export const formatDate3 = (date:Date) => !date ? (
    null
) : (
    new Intl.DateTimeFormat('en-US', {month: 'short'}).format(date) + " " +
    paddingLeft(date.getDate()) + ", " +
    paddingLeft(date.getFullYear())
);

export const formatDateTimeOnly = (date:Date) => !date ? (
    null
) : (
    date.toLocaleTimeString(
        'en-US',
        {
            hour: 'numeric',
            minute: 'numeric',            
        },
    )
);
